// extracted by mini-css-extract-plugin
export var arrows = "outfit-module--arrows--4fb4d";
export var cart = "outfit-module--cart--3c81b";
export var color = "outfit-module--color--97775";
export var head = "outfit-module--head--7d54e";
export var image = "outfit-module--image--de67b";
export var more = "outfit-module--more--e3805";
export var off = "outfit-module--off--a6564";
export var out_set = "outfit-module--out_set--e35a9";
export var out_text = "outfit-module--out_text--4bb22";
export var outfit = "outfit-module--outfit--3b86d";
export var outfit_title = "outfit-module--outfit_title--8d790";
export var outfit_wr = "outfit-module--outfit_wr--3cb23";
export var outfits = "outfit-module--outfits--1b551";
export var price = "outfit-module--price--24874";
export var title = "outfit-module--title--5bfbb";